import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LineOtherIncomeComponent } from '../line-other-income/line-other-income.component';
import { QuestionnaireService } from '../services/questionnaire.service';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { IncomesArrayComponent } from '../incomes-array/incomes-array.component';
import { ValidateDate } from '../date-validator';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-user-more-details',
	templateUrl: './user-more-details.component.html',
	styleUrls: ['./user-more-details.component.scss']
})
export class UserMoreDetailsComponent implements OnInit {
	private route$: Subscription;
	qID: any;
	prevQID: any;
	visibleQids;
	editQuestion;
	currentStep;
	userMoreDetails: FormGroup;
	submitted = false;
	console = console;
	window = window;

	//q1
	minBirthDate = {year: (new Date().getFullYear())-100, month: 1, day: 1}; //from -100 years
	maxBirthDate = {year: (new Date().getFullYear())-15, month: 12, day: 31};  //to 15 years old
	maritalStatus: string[] = ["רווק", "נשוי", "גרוש", "אלמן"];
	childrenNumber: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
	educationCombo: string[] = ["יסודית", "תיכונית", "על תיכונית", "אקדמאית"];
	//q2
	employmentStatusOptions;
	selectedEmploymentStatus;
	check:number = 0;
	check2:number = 0;
	defaultValue = "";

	//q4.1
	mainBorrowOtherIncome = [];
	typeCmbo: string[] = ["דמי מזונות", "מלגה", "קצבת נכות", "הכנסה משכ''ד", "אחר"];


	qFields = {
		1: [
			{ name: "birthDate", validators: [Validators.required, ValidateDate], type:"Date" },
			{ name: "maritalStatus", validators: [Validators.required] },
			{ name: "childrenNumber", validators: [Validators.required] },
			{ name: "education", validators: [Validators.required] },
		],
		2: [{ name: "employmentStatus", validators: [] }],
		'3.1-a':[{ name: "employersCompanyName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")]}],
		'3.1-b': [
			{ name: "employersCompanyField", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "employersProfession", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "employersCompanySeniority", validators: [Validators.required, Validators.pattern("^([0]\.[5-9]||[1-9]||[1-9]\.([1-9])||[1-6][0-9]\.([1-9])||[1-6][0-9]||[7][0])")] }
		],
        '3.1-c': [{ name: "employersMonthlyIncome", validators: [Validators.required] }],
		'3.2-a':[{ name: "independentCompanyName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")]}],
		'3.2-b': [
			{ name: "independentCompanyField", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "independentProfession", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "independentCompanySeniority", validators: [Validators.required, Validators.pattern("^([0]\.[5-9]||[1-9]||[1-9]\.([1-9])||[1-6][0-9]\.([1-9])||[1-6][0-9]||[7][0])")] }
		],
		'3.2-c': [{ name: "independentYearlyIncome", validators: [Validators.required] }],
		4: [{ name: "areThereOtherIncome", validators: [] }],
		'4-1': [{ name: "otherIncome", validators: [] }]
	};

	qArrFields = {
		'4-1': [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required, Validators.min(1)] },
			{ name: "source", validators:[Validators.required]}
		]
	};
	
	constructor(private route: ActivatedRoute,
		private activeRoute: ActivatedRoute,
		private questionnaireService: QuestionnaireService,
		private fb: FormBuilder
	) 
	{
		this.currentStep = this.questionnaireService.getStep("user-more-details");
	}

	ngOnInit() {		
		this.createForm();
		
		this.route$ = this.activeRoute.params.subscribe(params => {
			this.prevQID = this.qID;
			this.qID = params['qid'];
			this.editQuestion = null;


			if (params.qid === "all") {
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			} else {
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			}
		});

		this.employmentStatusOptions = [
			{ label: 'USER_MORE_DETAILS.QUESTION2.A1', id: "employee", class: "employee" },
			{ label: 'USER_MORE_DETAILS.QUESTION2.A2', id: "independent", class: "independent" },
			{ label: 'USER_MORE_DETAILS.QUESTION2.A3', id: "unemployed", class: "unemployed" },
			{ label: 'USER_MORE_DETAILS.QUESTION2.A4', id: "employeeAndIndependent", class: "employee-independent" }
		];
	}

	onEducationChange(value) {
		this.check2 =0
		for (let ed of this.educationCombo) {
			if(value == ed){
				this.check2 =1
			}
		}
	}


	createForm() {
		this.userMoreDetails = this.fb.group({ // <-- the parent FormGroup
			
			'birthDate': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			'maritalStatus': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[1].answerValue,		
			'childrenNumber': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[2].answerValue,
			'education': this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[3].answerValue,
			'employmentStatus': this.questionnaireService.getQuestion(this.currentStep, "2").selectedAnswer,
			'employersCompanyName': this.questionnaireService.getQuestion(this.currentStep, "3.1-a").answer.fields[0].answerValue,
			'employersCompanyField':  this.questionnaireService.getQuestion(this.currentStep, "3.1-b").answer.fields[0].answerValue,
			'employersProfession':  this.questionnaireService.getQuestion(this.currentStep, "3.1-b").answer.fields[1].answerValue,
			'employersCompanySeniority':  this.questionnaireService.getQuestion(this.currentStep, "3.1-b").answer.fields[2].answerValue,
			'independentCompanyName': this.questionnaireService.getQuestion(this.currentStep, "3.2-a").answer.fields[0].answerValue,
			'independentCompanyField':  this.questionnaireService.getQuestion(this.currentStep, "3.1-b").answer.fields[0].answerValue,
			'independentProfession':  this.questionnaireService.getQuestion(this.currentStep, "3.2-b").answer.fields[1].answerValue,
			'independentCompanySeniority':  this.questionnaireService.getQuestion(this.currentStep, "3.2-b").answer.fields[2].answerValue,

			'employersMonthlyIncome': this.questionnaireService.getQuestion(this.currentStep, "3.1-c").answer.fields[0].answerValue,
			'independentYearlyIncome': this.questionnaireService.getQuestion(this.currentStep, "3.2-c").answer.fields[0].answerValue,
			'areThereOtherIncome': this.questionnaireService.getQuestion(this.currentStep, "4").selectedAnswer,
			'otherIncome': IncomesArrayComponent.buildIncomes(this.questionnaireService.getQuestion(this.currentStep, "4-1").answer.fieldsArray)
			
		});
	}
	
	setValidators() {
		this.questionnaireService.clearAllQuestionValidators(this.userMoreDetails.controls, this.qFields, this.qArrFields);	
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.userMoreDetails.controls, this.qFields, "3", this.qArrFields, false);
		this.submitted = false;
	}


	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		}
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit(): valid=", valid, ", value=", value);
		value = this.userMoreDetails.getRawValue();
		this.submitted = true;
		if (valid||(this.check==1&&this.check2 ==1)) {
			this.check =0
			this.check2 =0
			let q;
			let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[submitQID];

			q.forEach(element => {
				if(element.type) {
					if (value[element.name].length) {
						for (let index = 0; index < value[element.name].length; index++) {
							value[element.name][index].borrowerBirthDate =  this.questionnaireService.customParse(value[element.name][index].borrowerBirthDate);
						}
					} else {
						value[element.name] = this.questionnaireService.customParse(value[element.name]);
					}
					
				}
			});

			let values = q.map(r => {
				return value[r.name];
			});
			this.questionnaireService.sendGA(this.currentStep,this.qID, values);
			this.nextClick(submitQID, values);
		} else{
			window["logInvalidControls"](this.userMoreDetails);
		}
	}

	editQuestionChange(qid) {
		this.qID = qid;
		this.setValidators();
	}
}



// WEBPACK FOOTER //
// ./src/app/user-more-details/user-more-details.component.ts